import axios from "axios";
//import axiosRetry from "axios-retry";
import qs from "qs";

// axiosRetry(axios, {
//   retries: 3, // Number of retry attempts
//   retryDelay: (retryCount) => {
//     console.log(`Retry attempt: ${retryCount}`);
//     return retryCount * 2000; // Exponential backoff (2s, 4s, 6s...)
//   },
//   retryCondition: (error) => {
//     // Retry on network errors or 5xx status codes
//     return (
//       error.code === "ECONNABORTED" ||
//       axiosRetry.isNetworkOrIdempotentRequestError(error) ||
//       error.response?.status >= 500
//     );
//   },
// });

export default {
  state: {},
  getters: {},
  mutations: {},
  actions: {
    addSessionDatatoStrapi({ getters }, sessionData) {
      let config = {
        method: "post",
        maxBodyLength: Infinity,
        url: "https://cms.il-lasalle.arsconnect.com/user-sessions",
        data: qs.stringify(sessionData),
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      };
      axios
        .request(config)
        .then(() => {
          console.log("Interaction Added to Strapi");
        })
        .catch((error) => {
          console.log("Error adding interaction to Strapi", error);
        });
    },
  },
};
